import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface CoresAplicativo {
    // Cores do Site
    corSitePrimaria: string
    corSiteSecundaria: string
    corSiteBarraFinalizar: string
    corSitePreco: string
    corSiteBotaoConfirmar: string
    // Cores do Aplicativo
    textPesquisaColor: string
    corCategoriaCardapio: string
    corPadrao: string
    corPadraoSecundaria: string
    corTitulosLabelPadrao: string
    corSubtitulos: string
    corBotoesCabecalho: string
    corBotoesRodape: string
    corTextoDestaque: string
    corPreco: string
    corBackground: string
    corBackgroundSplash: string
    corFundoCardapio: string
    corFundoMenuSelecionado: string
    corBarraEndereco: string
    corFonteBotoes: string
    corBackgroundPrimeiroAcesso: string
    corCabecalho: string
    corRodape: string
    // Cores dos Panfletos
    corFundoPanfleto: string
    // Indica se o estabelecimento tem app próprio (false = caiu no app global cliente_fiel)
    podeEditar?: boolean
}

export type AtualizarCoresPayload = Omit<CoresAplicativo, "podeEditar">

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

export const obterCores = async function (
    authorization: string
): Promise<CoresAplicativo | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<CoresAplicativo>>("aplicativoDados/ObterCoresAplicativo", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<CoresAplicativo>(response, "ObterCoresAplicativo")
    } catch (error) {
        RegistrarLogErro(error, "ObterCoresAplicativo", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const atualizarCores = async function (
    authorization: string,
    payload: AtualizarCoresPayload
): Promise<CoresAplicativo | ErroApi> {
    try {
        const response = await api
            .post<RespostaRaw<CoresAplicativo>>(
                "aplicativoDados/AtualizarCoresAplicativo",
                payload,
                {
                    headers: { "Content-Type": "application/json", Authorization: authorization },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<CoresAplicativo>(response, "AtualizarCoresAplicativo")
    } catch (error) {
        RegistrarLogErro(error, "AtualizarCoresAplicativo", JSON.stringify(payload))
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
